import { GET_TRACKING_ERROR, GET_TRACKING_REQUEST, GET_TRACKING_SUCCESS } from "./types";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");
//API for get all trackings

export const getTracking = (token, data) => dispatch => {
  dispatch({ type: GET_TRACKING_REQUEST });
  //API for get all trackings
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/tracking`,
    headers: {
      Accept: "application/json",
      'Authorization': 'Bearer ' + token
    },
    data
  })
    .then(response => {
      return dispatch({ type: GET_TRACKING_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: GET_TRACKING_ERROR,
        payload: [],
      });
    });
};
